<div class="page-header">
  <app-prev-next-button direction="left" label="estoque" (click)="navigateToStock()"></app-prev-next-button>
  <h1>Pallets com Endereço Desconhecido</h1>
</div>
<div class="ctrl-bar">
  <div class="buttons">
    <div class="inventory">
      <button mat-raised-button class="secondary-2" [disabled]="!selectedPallets.length"
        (click)="openSidenav('MISSING_CRATE_INVENTORY')">
        Inventariar
      </button>
    </div>

    <div class="update-button">
      <p>Atualizado às {{ actualHour }}</p>
      <button mat-raised-button (click)="update()">
        <i class="uil uil-sync"></i>
        <span>Atualizar</span>
      </button>
    </div>
  </div>
</div>
<app-side-color-card color="primary-1">
  <div content class="card-content">
    <div class="card-header">
      <h2>Pallets ({{ missingPalletsService.totalItems$ | async | number:'1.0-0':'pt-BR' }})</h2>
      <div class="paginator-container">
        <app-paginator
          [currentPage]="missingPalletsService.currentPage$ | async"
          [pageCount]="missingPalletsService.pageCount$ | async"
          [atFirstPage]="missingPalletsService.atFirstPage$ | async"
          [atLastPage]="missingPalletsService.atLastPage$ | async"
          [pageSize]="missingPalletsService.pageSize$ | async"
          [pageSizeOptions]="missingPalletsService.pageSizeOptions$ | async"
          (nextPage)="getNextPage($event)"
          (previousPage)="getPreviousPage($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (pageChange)="onPageChange($event)"
        ></app-paginator>
      </div>
    </div>
    <div class="table">
      <app-unknown-address-table
        [crates]="data"
        (clicked)="onRowClick($event)"
        (onFilterValuesChange)="onFiltersApply($event)">
      </app-unknown-address-table>
      <div *ngIf="isLoading" class="loader">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
      <div class="empty" *ngIf="data?.length === 0 && !isLoading">
        NÃO EXISTEM PALLETS COM ENDEREÇO DESCONHECIDO.
      </div>
    </div>
  </div>
</app-side-color-card>

<app-full-page-loader *ngIf="isModalLoading"></app-full-page-loader>